// extracted by mini-css-extract-plugin
export var attachmentContainer = "_m3-0";
export var fileList = "_m3-2";
export var removeFileButton = "_m3-1";